import { createApp } from "vue/dist/vue.esm-bundler.js"
import { useVuelidate } from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import recaptcha from '../components/recaptcha';

createApp({
    setup() {
        return { v$: useVuelidate() }
    },
    components: {
        VueDatePicker,
        recaptcha
    },
    data() {
        return {
            currentPage: 1,
            recaptchaPassed: false,
            page1: {
                firstName: '',
                lastName: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                email: '',
                confirmEmail: '',
                contact: false,
                phone: '',
                remember: true,
            },
            page2: {
                dateOfEvent: null,
                concern: null,
                comments: '',
            },
            pageProgress: 1
        };
    },
    computed: {
        submitEnabled() {
            return this.recaptchaPassed;
        }
    },
    methods: {
        async validatePage(page) {

            var isValid = await this.v$.page1.$validate();

            return isValid;
        },
        goToPage(page) {
            this.currentPage = page;
        },
        async nextPage() {
            if (await this.validatePage(1)) {
                this.currentPage = 2;
                this.pageProgress = 2;
            }
        },
        previousPage() {
            this.currentPage = 1;
        },
        recaptchaCallback(newState) {
            this.recaptchaPassed = newState;
        },
        async submitForm() {
            var isValid = await this.v$.page2.$validate();

            if (isValid) {
                $('#noiseComplaintPageForm').submit();
            }
        }
    },
    validations() {
        return {
            page1: {
                firstName: { required },
                lastName: { required },
                address: { required },
                city: { required },
                state: { required },
                zip: { required },
                email: { required, email },
                confirmEmail: { required, email },
                contact: { required },
            },
            page2: {
                dateOfEvent: { required },
                concern: { required }
            }
        }
    }
}).mount('#noiseComplaintFormApp');